import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const ListBulletedIcon = React.memo(function ListBulletedIcon(props: TListBulletedIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Bulleted List" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 7.5C5.05228 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.05228 5.5 4.5 5.5C3.94772 5.5 3.5 5.94772 3.5 6.5C3.5 7.05228 3.94772 7.5 4.5 7.5ZM8 5.75C7.72386 5.75 7.5 5.97386 7.5 6.25V6.75C7.5 7.02614 7.72386 7.25 8 7.25H18C18.2761 7.25 18.5 7.02614 18.5 6.75V6.25C18.5 5.97386 18.2761 5.75 18 5.75H8ZM8 10.25C7.72386 10.25 7.5 10.4739 7.5 10.75V11.25C7.5 11.5261 7.72386 11.75 8 11.75H18C18.2761 11.75 18.5 11.5261 18.5 11.25V10.75C18.5 10.4739 18.2761 10.25 18 10.25H8ZM7.5 15.25C7.5 14.9739 7.72386 14.75 8 14.75H18C18.2761 14.75 18.5 14.9739 18.5 15.25V15.75C18.5 16.0261 18.2761 16.25 18 16.25H8C7.72386 16.25 7.5 16.0261 7.5 15.75V15.25ZM5.5 11C5.5 11.5523 5.05228 12 4.5 12C3.94772 12 3.5 11.5523 3.5 11C3.5 10.4477 3.94772 10 4.5 10C5.05228 10 5.5 10.4477 5.5 11ZM4.5 16.5C5.05228 16.5 5.5 16.0523 5.5 15.5C5.5 14.9477 5.05228 14.5 4.5 14.5C3.94772 14.5 3.5 14.9477 3.5 15.5C3.5 16.0523 3.94772 16.5 4.5 16.5Z"
            />
        </IconBase>
    );
});

export default ListBulletedIcon;

// #region Types

export type TListBulletedIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <ListBulletedIcon />
        : { ...IconBaseExample, render: ListBulletedIcon };

// #endregion
